module.exports = __webpack_public_path__ + "img/casa_mujeres mates.317468e8.webp";